import _ from 'underscore';
import Backbone from 'backbone';
import NavigationUtil from 'utils/NavigationUtil';
import CourseElevation from 'models/course/CourseElevation';
import MapViewUtils from 'views/map/MapViewUtils';
import Util from 'views/utils/LeafletMap/utils/Util';

export default Backbone.Collection.extend({
    model: CourseElevation,

    initialize: function(args) {
        this.isFromImport = false;
        if (args.isFromImport) {
            this.isFromImport = args.isFromImport;
        }
    },

    backend: 'gcapi',

    url: function() {
        if (MapViewUtils.userInChina()) {
            let coordinateSystem = Util.CoordinateSystem.BD09;
            if (this.isFromImport) {
                coordinateSystem = Util.CoordinateSystem.WGS84;
            }
            return '/course-service/course/elevation/from/' + coordinateSystem + '/CN';
        } else {
            return '/course-service/course/elevation';
        }
    },

    fetch: function(opts) {
        var options = opts || {};
        options.url = this.url();
        options.contentType = 'application/json';
        options.type = 'POST';
        options.data = this.getFormatedData();
        return Backbone.Collection.prototype.fetch.call(this, options);
    },

    /**
     * Converts the models into the format the endpoint expects
     */
    getFormatedData: function() {
        var data = [];

        _.each(this.models, function(model) {
            if (model.getLatitude() !== null && model.getLongitude() !== null) {
                data.push([model.getLatitude(), model.getLongitude(), null]);
            }
        });

        return JSON.stringify(data);
    },

    getElevationByLatLng: function(lat, lng) {
        var foundModel = this.findWhere({
            latitude: lat,
            longitude: lng
        });

        return foundModel ? foundModel.getElevation() : null;
    },

    parse: function(response) {
        if (response) {
            var elevations = [];

            _.each(response, function(a) {
                elevations.push(
                    new CourseElevation({
                        latitude: a[0],
                        longitude: a[1],
                        elevation: a[2]
                    })
                );
            });

            return elevations;
        }
    }
});
